import { render } from "./adminCounsel.vue?vue&type=template&id=796089e6&scoped=true"
import script from "./adminCounsel.vue?vue&type=script&lang=js"
export * from "./adminCounsel.vue?vue&type=script&lang=js"

import "./adminCounsel.vue?vue&type=style&index=0&id=796089e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796089e6"]])

export default __exports__